module.exports = __webpack_public_path__ + "static/media/tooltip.1a4c7fc2.less";